import React, { createContext, useContext } from 'react';

interface IEditorProviderProps {
  isEditor?: boolean;
}

const EditorContext = createContext<boolean | undefined>(undefined);

export const EditorProvider: React.FC<React.PropsWithChildren<IEditorProviderProps>> = ({
  children,
  isEditor = false,
}) => {
  return <EditorContext.Provider value={isEditor}>{children}</EditorContext.Provider>;
};

export const useIsEditor = (): boolean => {
  const context = useContext(EditorContext);

  return context || false;
};
